import React, { useState } from 'react';
import { Calendar, Clock, User, Mail, Phone, MessageSquare } from 'lucide-react';
type Status = 'idle' | 'submitting' | 'success' | 'error';
const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xqejbozd';
export function Book() {
  const [status, setStatus] = useState<Status>('idle');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data: Record<string, string> = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });
    setStatus('submitting');
    try {
      const response = await fetch(FORMSPREE_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (response.ok) {
        form.reset();
        setStatus('success');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  const resetForm = () => setStatus('idle');
  return <div className="w-full bg-white min-h-screen" data-id="element-257" data-mp="jv8fes076uva">
      <section className="py-12 md:py-20" data-id="element-258" data-mp="jwjj6rtn82me">
        <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-259" data-mp="xuzqokzbxx5l">
          <div className="flex flex-col md:flex-row gap-12 lg:gap-20" data-id="element-260" data-mp="xsdjimgcpjnw">
            {/* Info Column */}
            <div className="flex-1" data-id="element-261" data-mp="tv94yvonu77x">
              <h1 className="font-bebas text-5xl md:text-7xl mb-6 tracking-wide" data-id="element-262" data-mp="17rw1ixcpavdb">
                Book Your
                <br data-id="element-263" data-mp="12sjfufxkfucb" />
                <span className="text-reach-red" data-id="element-264" data-mp="12t1j3winb8tq">Consultation</span>
              </h1>
              <p className="font-inter text-lg text-reach-black mb-10" data-id="element-265" data-mp="1hh5tmd7joe1f">
                Take the first step towards elite performance. Fill out the form
                to schedule a free facility tour and athlete evaluation.
              </p>

              <div className="space-y-6" data-id="element-266" data-mp="1qgsu8wsg9ftf">
                <div className="flex items-start gap-4" data-id="element-267" data-mp="1ll3tiq4p1svj">
                  <div className="w-12 h-12 bg-reach-gray rounded-full flex items-center justify-center shrink-0" data-id="element-268" data-mp="j6mqrx78vo48">
                    <Calendar className="text-reach-red" size={24} data-id="element-269" data-mp="o5hhrmfd8izf" />
                  </div>
                  <div data-id="element-270" data-mp="s7kx4m55o7pz">
                    <h3 className="font-bebas text-2xl tracking-wide mb-1" data-id="element-271" data-mp="s72pktd1m72r">
                      What to expect
                    </h3>
                    <p className="font-inter text-sm text-gray-600" data-id="element-272" data-mp="wzcfi9e5r751">
                      A 30-minute walkthrough of INPOWERiQ and a discussion of
                      your athlete's specific goals.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-273" data-mp="1bwd80f46b64k">
                  <div className="w-12 h-12 bg-reach-gray rounded-full flex items-center justify-center shrink-0" data-id="element-274" data-mp="1fwx1n8pjfrly">
                    <Clock className="text-reach-red" size={24} data-id="element-275" data-mp="3dn6qpb9gk3gs" />
                  </div>
                  <div data-id="element-276" data-mp="3ho0em4mwhi9o">
                    <h3 className="font-bebas text-2xl tracking-wide mb-1" data-id="element-277" data-mp="3hnidatldsduw">
                      Flexible Scheduling
                    </h3>
                    <p className="font-inter text-sm text-gray-600" data-id="element-278" data-mp="3a6u4zn5cmr2j">
                      We'll contact you within 24 hours to find a time that
                      works for your family's schedule.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Form Column */}
            <div className="flex-1" data-id="element-279" data-mp="3t453v6n2jihg">
              <div className="bg-reach-gray p-8 rounded-lg border-t-4 border-reach-red" data-id="element-280" data-mp="3t33fy1kyf1ib">
                {status === 'success' ? <div className="text-center py-12" data-id="element-281" data-mp="3o2pjlgsptg04">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-282" data-mp="3k1m3ct6r9hyd">
                      <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-283" data-mp="3f3kl2ah5lmny">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-284" data-mp="3rk24wa7ur4xd" />
                      </svg>
                    </div>
                    <h3 className="font-bebas text-3xl tracking-wide mb-4" data-id="element-285" data-mp="3mmtjm0reqkrw">
                      Thanks, your message is in
                    </h3>
                    <p className="font-inter text-reach-black mb-6" data-id="element-286" data-mp="j5bc5ufjrfs0">
                      Coach Fernando typically responds within 24 hours.
                    </p>
                    <button type="button" onClick={resetForm} className="inline-flex items-center justify-center font-inter font-semibold text-sm uppercase tracking-wider px-5 py-2.5 border-2 border-reach-black text-reach-black rounded hover:bg-reach-black hover:text-white transition-colors" data-id="element-287" data-mp="57wkej1tmvwv">
                      Send another
                    </button>
                  </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-288" data-mp="2ic8n4o7uvq1t">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-289" data-mp="2wb8c5wza66yi">
                      <div data-id="element-290" data-mp="2rcoons51gn41">
                        <label htmlFor="parentName" className="block font-inter text-sm font-semibold mb-2" data-id="element-291" data-mp="2rehwhare1ddm">
                          Parent/Guardian Name
                        </label>
                        <div className="relative" data-id="element-292" data-mp="2dd5j973m3pvf">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-293" data-mp="2deq9wlmt2oo0">
                            <User size={18} className="text-gray-400" data-id="element-294" data-mp="28km3q4ld6knz" />
                          </div>
                          <input type="text" id="parentName" name="parentName" required className="w-full pl-10 pr-4 py-3 bg-white border border-gray-300 rounded focus:outline-none focus:border-reach-red focus:ring-1 focus:ring-reach-red transition-colors font-inter" placeholder="John Doe" data-id="element-295" data-mp="1kurr9o4yiy49" />
                        </div>
                      </div>
                      <div data-id="element-296" data-mp="2x26r918ruckk">
                        <label htmlFor="athleteName" className="block font-inter text-sm font-semibold mb-2" data-id="element-297" data-mp="2x2zq7g1hnxs5">
                          Athlete Name
                        </label>
                        <div className="relative" data-id="element-298" data-mp="3b1pmwukebvfz">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-299" data-mp="3b2hja7lthx7b">
                            <User size={18} className="text-gray-400" data-id="element-300" data-mp="le8g5nj1snj3" />
                          </div>
                          <input type="text" id="athleteName" name="athleteName" required className="w-full pl-10 pr-4 py-3 bg-white border border-gray-300 rounded focus:outline-none focus:border-reach-red focus:ring-1 focus:ring-reach-red transition-colors font-inter" placeholder="Jane Doe" data-id="element-301" data-mp="qcs57wsxuffo" />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-302" data-mp="cnqfhboh9plk">
                      <div data-id="element-303" data-mp="7r9o88lzev49">
                        <label htmlFor="email" className="block font-inter text-sm font-semibold mb-2" data-id="element-304" data-mp="7qi3xtxu4jta">
                          Email Address
                        </label>
                        <div className="relative" data-id="element-305" data-mp="1y2eb3lmhyk9d">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-306" data-mp="1y0jo81ro0i2n">
                            <Mail size={18} className="text-gray-400" data-id="element-307" data-mp="2hds1rs69xqsb" />
                          </div>
                          <input type="email" id="email" name="email" required className="w-full pl-10 pr-4 py-3 bg-white border border-gray-300 rounded focus:outline-none focus:border-reach-red focus:ring-1 focus:ring-reach-red transition-colors font-inter" placeholder="john@example.com" data-id="element-308" data-mp="27lm90g8775c2" />
                        </div>
                      </div>
                      <div data-id="element-309" data-mp="1tmuvaux8zlog">
                        <label htmlFor="phone" className="block font-inter text-sm font-semibold mb-2" data-id="element-310" data-mp="1tm3bsigxdeej">
                          Phone Number
                        </label>
                        <div className="relative" data-id="element-311" data-mp="1xvhsjn999tl">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-312" data-mp="1wapl0oey2yw">
                            <Phone size={18} className="text-gray-400" data-id="element-313" data-mp="3t2vcq9bckqqn" />
                          </div>
                          <input type="tel" id="phone" name="phone" required className="w-full pl-10 pr-4 py-3 bg-white border border-gray-300 rounded focus:outline-none focus:border-reach-red focus:ring-1 focus:ring-reach-red transition-colors font-inter" placeholder="(555) 123-4567" data-id="element-314" data-mp="600cllpfwcht" />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-315" data-mp="2vhg2k6wwmq2z">
                      <div data-id="element-316" data-mp="2rge1rlnca5yw">
                        <label htmlFor="age" className="block font-inter text-sm font-semibold mb-2" data-id="element-317" data-mp="2rh5m20bhkh9v">
                          Athlete Age
                        </label>
                        <select id="age" name="age" required className="w-full px-4 py-3 bg-white border border-gray-300 rounded focus:outline-none focus:border-reach-red focus:ring-1 focus:ring-reach-red transition-colors font-inter" data-id="element-318" data-mp="2ge7p3o7eu0hx">
                          <option value="" data-id="element-319" data-mp="346o5lubi1kf4">Select age</option>
                          <option value="8-11" data-id="element-320" data-mp="2zcah8bv98djy">8-11 (Youth)</option>
                          <option value="12-14" data-id="element-321" data-mp="2uf0keb5jczm3">12-14 (Middle School)</option>
                          <option value="15-18" data-id="element-322" data-mp="3rtwa4a13spg3">15-18 (High School)</option>
                          <option value="18+" data-id="element-323" data-mp="3rv7hskxo6hch">18+ (College/Pro)</option>
                          <option value="pro-collegiate" data-id="element-324" data-mp="3n2eabpatguwp">
                            Pro / Collegiate
                          </option>
                        </select>
                      </div>
                      <div data-id="element-325" data-mp="38svhb41z3x2">
                        <label htmlFor="sport" className="block font-inter text-sm font-semibold mb-2" data-id="element-326" data-mp="3a3yv9tl69nn">
                          Primary Sport
                        </label>
                        <input type="text" id="sport" name="sport" className="w-full px-4 py-3 bg-white border border-gray-300 rounded focus:outline-none focus:border-reach-red focus:ring-1 focus:ring-reach-red transition-colors font-inter" placeholder="e.g. Football, Soccer" data-id="element-327" data-mp="h8kfbsh93eiz" />
                      </div>
                    </div>

                    <div data-id="element-328" data-mp="14wvb4h83ao0e">
                      <label htmlFor="goals" className="block font-inter text-sm font-semibold mb-2" data-id="element-329" data-mp="14yep2169wmz0">
                        Goals / Notes
                      </label>
                      <div className="relative" data-id="element-330" data-mp="2wx3dbnb5m9xi">
                        <div className="absolute top-3 left-3 pointer-events-none" data-id="element-331" data-mp="3arct8l59hoev">
                          <MessageSquare size={18} className="text-gray-400" data-id="element-332" data-mp="35z2z0sx4626s" />
                        </div>
                        <textarea id="goals" name="goals" rows={4} className="w-full pl-10 pr-4 py-3 bg-white border border-gray-300 rounded focus:outline-none focus:border-reach-red focus:ring-1 focus:ring-reach-red transition-colors font-inter resize-none" placeholder="What are you looking to improve?" data-id="element-333" data-mp="3knplrfp2lw81"></textarea>
                      </div>
                    </div>

                    <button type="submit" disabled={status === 'submitting'} className="btn-primary w-full disabled:opacity-60 disabled:cursor-not-allowed" data-id="element-334" data-mp="1vb5bbqutj37n">
                      {status === 'submitting' ? 'Sending' : 'Submit Request'}
                    </button>

                    {status === 'error' && <p className="font-inter text-sm text-red-600 text-center" data-id="element-335" data-mp="1gdcn7xwyvrx9">
                        Something went wrong. Please email
                        Fernando@reachperformancehq.com or call 708-980-4666.
                      </p>}
                  </form>}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}